<template>
  <div class="leads_box">
    <div class="leads_box--top">
      <div class="leads_box--top--header">
        <h2>Leads To Work</h2>
      </div>

      <date-selector
        v-model="selectedDate"
        include-past-due
        @input="setDate"
      />
    </div>

    <div class="leads_box--bottom">
      <app-loading-section :loading="loading" style="height: 100%">
        <tabs-horizontal
          class="leads_box--tabs"
          expanded
          :value="currentTab"
          @input="setTab"
        >
          <b-tab-item :value="ENUMS.StatusStateEnum.Contacting.key">
            <template #header>
              <span>Contact Not Made</span>
              <badge-default
                v-if="contactNotMadePastDueCount"
                class="ml-25"
                :count="contactNotMadePastDueCount"
                type="danger"
              />
              <badge-default
                v-if="contactNotMadeDueTodayCount"
                class="ml-25"
                :count="contactNotMadeDueTodayCount"
                type="warning"
              />
            </template>

            <user-dashboard-lead-item
              v-for="task in tasks"
              :key="task.id"
              :store-task="task"
              @editTask="openTaskModal"
            />
          </b-tab-item>

          <b-tab-item :value="ENUMS.StatusStateEnum.Active.key">
            <template #header>
              <span>Active</span>
              <badge-default
                v-if="activePastDueCount"
                class="ml-25"
                :count="activePastDueCount"
                type="danger"
              />
              <badge-default
                v-if="activeDueTodayCount"
                class="ml-25"
                :count="activeDueTodayCount"
                type="warning"
              />
            </template>

            <user-dashboard-lead-item
              v-for="task in tasks"
              :key="task.id"
              :store-task="task"
              @editTask="openTaskModal"
            />
          </b-tab-item>

          <b-tab-item :value="ENUMS.StatusStateEnum.FollowUp.key">
            <template #header>
              <span>Follow Up</span>
              <badge-default
                v-if="followUpPastDueCount"
                class="ml-25"
                :count="followUpPastDueCount"
                type="danger"
              />
              <badge-default
                v-if="followUpDueTodayCount"
                class="ml-25"
                :count="followUpDueTodayCount"
                type="warning"
              />
            </template>

            <user-dashboard-lead-item
              v-for="task in tasks"
              :key="task.id"
              :store-task="task"
              @editTask="openTaskModal"
            />
          </b-tab-item>
        </tabs-horizontal>
      </app-loading-section>
    </div>

    <!-- Task Modal -->
    <modal-container>
      <modal-crud-form
        ref="taskModal"
        title="Task"
        form-component="task-form"
        is-double-column
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import UserDashboardLeadItem from "./UserDashboardLeadItem";
import {ENUMS} from "../../../services/enums";
import UpNextTaskItem from "../../up-next/components/UpNextTaskItem.vue";
import dates from "../../../services/dates";
import DateSelector from "./DateSelector.vue";

export default {
  name: "UserDashboardLeadsBox",
  components: {DateSelector, UpNextTaskItem, UserDashboardLeadItem},
  data() {
    return {
      loading: true,
      selectedDate: dates.getTodayISO(),
      currentTab: ENUMS.StatusStateEnum.Contacting.key,
    }
  },
  mounted() {
    this.setTab(this.currentTab)
  },
  destroyed() {
    this.reset()
  },
  computed: {
    contactNotMadePastDueCount() {
      return this.$store.getters["dashboard/contactingBadges"].pastDue
    },
    contactNotMadeDueTodayCount() {
      return this.$store.getters["dashboard/contactingBadges"].dueToday
    },
    followUpPastDueCount() {
      return this.$store.getters["dashboard/followUpBadges"].pastDue
    },
    followUpDueTodayCount() {
      return this.$store.getters["dashboard/followUpBadges"].dueToday
    },
    activePastDueCount() {
      return this.$store.getters["dashboard/activeBadges"].pastDue
    },
    activeDueTodayCount() {
      return this.$store.getters["dashboard/activeBadges"].dueToday
    },
    contactNotMadeTasks() {
      return this.$store.getters["dashboardContacting/tasks"]
    },
    activeTasks() {
      return this.$store.getters["dashboardActive/tasks"]
    },
    followUpTasks() {
      return this.$store.getters["dashboardFollowUp/tasks"]
    },
    tasks() {
      if (this.currentTab === ENUMS.StatusStateEnum.Contacting.key) return this.contactNotMadeTasks

      if (this.currentTab === ENUMS.StatusStateEnum.Active.key) return this.activeTasks

      if (this.currentTab === ENUMS.StatusStateEnum.FollowUp.key) return this.followUpTasks

      return []
    },
  },
  methods: {
    setTab(tabValue) {
      this.loading = true
      this.currentTab = tabValue
      this.reset()

      if (this.currentTab === ENUMS.StatusStateEnum.Contacting.key) {
        this.$store.dispatch('dashboardContacting/setup', this.selectedDate)
          .finally(() => this.loading = false)
      }

      if (this.currentTab === ENUMS.StatusStateEnum.Active.key) {
        this.$store.dispatch('dashboardActive/setup', this.selectedDate)
          .finally(() => this.loading = false)
      }

      if (this.currentTab === ENUMS.StatusStateEnum.FollowUp.key) {
        this.$store.dispatch('dashboardFollowUp/setup', this.selectedDate)
          .finally(() => this.loading = false)
      }
    },
    setDate() {
      this.setTab(this.currentTab)
    },
    reset() {
      this.$store.dispatch("dashboardContacting/tearDown")
      this.$store.dispatch("dashboardActive/tearDown")
      this.$store.dispatch("dashboardFollowUp/tearDown")
    },
    openTaskModal(task) {
      this.$refs.taskModal.open(task);
    },
  },
}
</script>

<style lang="scss" scoped>

.leads_box {
  height: 100%;

  &--top {
    display: flex;
    justify-content: space-between;
    padding: 14px 14px 0;

    &--header {
      display: flex;
    }

    h2 {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      line-height: 1;
    }
  }

  &--bottom {
    height: 100%;
    margin-top: 1rem;
  }
}

.leads_box--tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
}

:deep(.tab-content) {
  height: calc(100% - 110px);
  padding: 0.5rem 0.5rem;
  overflow-y: scroll;
  overflow-x: hidden;
}

:deep(.date_selector) {
  width: 320px;
  border-bottom: 0;
}
</style>
